import React from "react";

const About = () => {
  return (
    <div className="container">
      <section id="about" className="mt-2 section feature-box mb-5">
        <h2 className="text-center text-uppercase my-2 pt-5">
          About <strong>me</strong>
        </h2>

        <p className="text-center w-responsive mx-auto my-2 mb-4 font-weight-bolder">
          I am a full-stack Web developer & Graphic designer with a passion for
          metrics and beating former "best-yets." Building (and occasionally
          designing) exceptional websites, applications, and everything in
          between.
        </p>

        <div className="row features-big text-center">
          <div className="col-md-4 mb-5">
            <div className="card card-body hoverable">
              <i
                className="fas fa-laptop fa-3x mb-4 orange-text"
                aria-hidden="true"
              ></i>

              <h5 className="font-weight-bold text-uppercase mb-4 orange-text">
                Freelancer
              </h5>

              <p className="dark-grey-text">
                Developed many freelance project & advertising content for
                various platforms while ensuring maximum brand awareness of
                target audience.
              </p>
            </div>
          </div>

          <div className="col-md-4 mb-5">
            <div className="card card-body yellow hoverable">
              <i
                className="fas fa-code fa-3x mb-4 black-text"
                aria-hidden="true"
              ></i>

              <h5 className="font-weight-bold text-uppercase black-text mb-4">
                Developer
              </h5>

              <p className="dark-grey-text">
                I am a full-stack Web developer having 2+ years of experience
                includes programming, debugging, designing, and wireframes
              </p>
            </div>
          </div>

          <div className="col-md-4 mb-5">
            <div className="card card-body hoverable">
              <i
                className="fas fa-pencil-alt fa-3x mb-4 orange-text"
                aria-hidden="true"
              ></i>

              <h5 className="font-weight-bold text-uppercase mb-4 orange-text">
                Designer
              </h5>

              <p className="dark-grey-text">
                Developed 500+ graphics, layouts (banners, posters, event
                themes, cards), and 50+ logos for local shops in brand
                development.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
